
function Footer() {
  return (
    <div className="flex flex-col w-full bg-dark-900 items-start bottom-0 mt-auto">
      <div className=" w-full border-b border-dark-700">
        <div className="justify-between flex flex-col md:flex-row w-full px-12 py-8 gap-8">
          <div className="flex flex-col gap-1 md:gap-4 md:flex-row">
            {/* <a href="/"><h3 className="font-body font-light text-md text-dark-500 hover:text-dark-400">Instagram</h3></a> */}
            <a target="blank" href="https://www.linkedin.com/in/lisanne-verbeet/"><h3 className="font-body font-light text-md text-secondary hover:text-dark-400">LinkedIn</h3></a>
            <a href="/"><h3 className="font-body font-light text-md cursor-default text-dark-500">x</h3></a>
            <a href="mailto:lisanneverbeet@outlook.com"><h3 className="font-body font-light text-md text-dark-500 hover:text-dark-400">lisanneverbeet@outlook.com</h3></a>
          </div>
          <h3 className="font-body font-light text-md text-darkgrey cursor-default">Eindhoven, NL</h3>
        </div>
      </div>
      <div className="flex flex-row justify-between w-full px-12 py-4">
        <h3 className="font-body font-light text-md text-dark-500 cursor-default">© 2025</h3>
        <h3 className="font-body font-light text-md text-dark-500 cursor-default">Lisanne Verbeet</h3>
      </div>
    </div>
  )
}

export default Footer
